module.exports = __webpack_public_path__ + "media/virtual-gallery/GalleryFocus2-f27188ba.jpg";